import { render, staticRenderFns } from "./open-in-new.vue?vue&type=template&id=94df8f18"
import script from "./open-in-new.vue?vue&type=script&lang=js"
export * from "./open-in-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports